"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _createSvg = require("../createSvg");
var _interfaces = require("../interfaces");
var _SVGIconWithSizes;
var _default = (0, _createSvg.createSvg)('IconMoreVertical', new _interfaces.SVGIconWithSizes((_SVGIconWithSizes = {}, (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.ExtraSmall, {
  paths: ['M8 3.5C7.30964 3.5 6.75 2.94036 6.75 2.25 6.75 1.55964 7.30964 1 8 1 8.69036 1 9.25 1.55964 9.25 2.25 9.25 2.94036 8.69036 3.5 8 3.5zM8 9.25C7.30964 9.25 6.75 8.69036 6.75 8 6.75 7.30964 7.30964 6.75 8 6.75 8.69036 6.75 9.25 7.30964 9.25 8 9.25 8.69036 8.69036 9.25 8 9.25zM6.75 13.75C6.75 14.4404 7.30964 15 8 15 8.69036 15 9.25 14.4404 9.25 13.75 9.25 13.0596 8.69036 12.5 8 12.5 7.30964 12.5 6.75 13.0596 6.75 13.75z'],
  params: {
    height: '16',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 16,
  width: 16
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Small, {
  paths: ['M9.99995 4.5C9.03346 4.5 8.24995 3.7165 8.24995 2.75 8.24995 1.7835 9.03346 1 9.99995 1 10.9665 1 11.75 1.7835 11.75 2.75 11.75 3.7165 10.9665 4.5 9.99995 4.5zM9.94995 11.75C8.98345 11.75 8.19995 10.9665 8.19995 10 8.19995 9.0335 8.98345 8.25 9.94995 8.25 10.9164 8.25 11.7 9.0335 11.7 10 11.7 10.9665 10.9164 11.75 9.94995 11.75zM8.24994 17.25C8.24994 18.2165 9.03344 19 9.99994 19 10.9664 19 11.7499 18.2165 11.7499 17.25 11.7499 16.2835 10.9664 15.5 9.99994 15.5 9.03344 15.5 8.24994 16.2835 8.24994 17.25z'],
  params: {
    height: '20',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 20,
  width: 20
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Medium, {
  paths: ['M12 5.5C10.7574 5.5 9.75 4.49264 9.75 3.25 9.75 2.00736 10.7574 1 12 1 13.2426 1 14.25 2.00736 14.25 3.25 14.25 4.49264 13.2426 5.5 12 5.5zM12 14.25C10.7574 14.25 9.75 13.2426 9.75 12 9.75 10.7574 10.7574 9.75 12 9.75 13.2426 9.75 14.25 10.7574 14.25 12 14.25 13.2426 13.2426 14.25 12 14.25zM9.75 20.75C9.75 21.9926 10.7574 23 12 23 13.2426 23 14.25 21.9926 14.25 20.75 14.25 19.5074 13.2426 18.5 12 18.5 10.7574 18.5 9.75 19.5074 9.75 20.75z'],
  params: {
    height: '24',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 24,
  width: 24
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Large, {
  paths: ['M16 7C14.3431 7 13 5.65685 13 4 13 2.34315 14.3431 1 16 1 17.6569 1 19 2.34315 19 4 19 5.65685 17.6569 7 16 7zM16 19C14.3431 19 13 17.6569 13 16 13 14.3431 14.3431 13 16 13 17.6569 13 19 14.3431 19 16 19 17.6569 17.6569 19 16 19zM13 28C13 29.6569 14.3431 31 16 31 17.6569 31 19 29.6569 19 28 19 26.3431 17.6569 25 16 25 14.3431 25 13 26.3431 13 28z'],
  params: {
    height: '32',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 32,
  width: 32
}), _SVGIconWithSizes)));
exports.default = _default;